import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
// import icon from "../../Assets/location.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapPin } from '@fortawesome/free-solid-svg-icons';

mapboxgl.accessToken = 'pk.eyJ1IjoiZXJmYW5rMjQ1IiwiYSI6ImNsN3l5Zmw5ZDE5ejMzb3MyaG56Nmx1cWEifQ.l7oJr7BgIOpspkyzc7nmSw';

const Style = styled.div`
    min-height: 35vh;
    width: 100%;
    display: block;
    position: relative;
    .map-container {
        position: absolute;
        inset: 0 0 0 0;
        width: 100%;
        height: 100%;
        display: block;
        overflow: visible;
        .mapboxgl-ctrl-attrib-inner {
            display: none;
        }
        .mapboxgl-ctrl-logo {
            display: none;
        }
        .mgl-map {
            height: 100%;
            width: 100%;
        }
    }
    .my-icon{
        border: 2px solid #dedede;
    }
`;

export default function Map(props) {
    const [lng] = useState(51.421859);
    const [lat] = useState(35.724759);
    const [zoom] = useState(10);
    const mapRef = useRef();
    var map = {}
    useEffect(() => {
        var pluginStatus = mapboxgl.getRTLTextPluginStatus();
        if(pluginStatus === 'unavailable'){
            mapboxgl.setRTLTextPlugin('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.0/mapbox-gl-rtl-text.js');
        }
        map = new mapboxgl.Map({
            container: mapRef.current,
            style: {
                'version': 8,
                'sources': {
                    'raster-tiles': {
                        'type': 'raster',
                        'tiles': [
                            'https://map.ir/shiveh/xyz/1.0.0/Shiveh:Shiveh@EPSG:3857@png/{z}/{x}/{y}.png?x-api-key=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImI1YWFlY2E1Zjg0NTdiNTVhZDQzMDc0N2Y2M2U3Y2I1M2Y2Y2Y0MDNhYzI0MDU5ZGRmYzQxZjk2NjY5NGRkZDc3ZDdmYTAyZTI2NDJiY2M4In0.eyJhdWQiOiIxNDM3NSIsImp0aSI6ImI1YWFlY2E1Zjg0NTdiNTVhZDQzMDc0N2Y2M2U3Y2I1M2Y2Y2Y0MDNhYzI0MDU5ZGRmYzQxZjk2NjY5NGRkZDc3ZDdmYTAyZTI2NDJiY2M4IiwiaWF0IjoxNjIzODI4NDc5LCJuYmYiOjE2MjM4Mjg0NzksImV4cCI6MTYyNjMzNDA3OSwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.J3Xzm7MfDXRP4IjOGMKx2VUvxQO9d0YfEvXLqT-QSIx9W1l8J7wCVaZShk1rgArQQQHgYEUApGaAuhBy93be_X28VHZQiSGDR3deez5nH3SYDltW0u94Rp_bOjGlFhBAMsvfOPDaDkG5KasJ-mpuoaoQDsokOUyl_tUTHZdyi_AkjKG3TzPXFjziezQxmgBnprHPuo_0VLsfcla2PHJrQfuqFJ19gzIa_m80wXrEZ8KiWVe7NKsIjssOHJ7V0PnBPPUBtViRZpBAlVnPZqvU0Ta095Vr1FULmAJ1h-nFMYmUx32jfD__CXcN8Elg8cNFfOiKcSN_khEtGUIXf7JLkw'
                        ],
                        'tileSize': 256,
                        'attribution':
                        'Map tiles by <a target="_top" rel="noopener" href="http://stamen.com">Stamen Design</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>. Data by <a target="_top" rel="noopener" href="http://openstreetmap.org">OpenStreetMap</a>, under <a target="_top" rel="noopener" href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
                    }
                },
                'layers': [
                    {
                        'id': 'simple-tiles',
                        'type': 'raster',
                        'source': 'raster-tiles',
                        'minzoom': 0,
                        'maxzoom': 22
                    }
                ]
            },
            center: [lng, lat], // starting position
            zoom: zoom, // starting zoom
            interactive: false
        });
        
        var marker = new mapboxgl.Marker({
                element: document.getElementById('map-icon'),
            }).setLngLat([lng, lat])
            .addTo(map);
        
        map.addControl(new mapboxgl.NavigationControl());
        
        map.on("load", (event) => {
            map.resize();
            map.flyTo({
                center: [lng, lat],
                zoom: 15,
                essential: true, // this animation is considered essential with respect to prefers-reduced-motion
            });
        })
    }, [])

    

    return (
      <Style>
        <div ref={mapRef} className="map-container" />
        <div style={{display: 'none'}}>
            <FontAwesomeIcon icon={faMapPin}style={{width: '2rem', height: '2rem' ,color:'var(--secondry-5)'}}  id={"map-icon"} alt={"icon"}/>
        </div>
      </Style>
  );
}